export default __webpack_public_path__ + "static/media/delete.a46c9fbd.svg";